"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Styled = _interopRequireWildcard(require("./AppBar.styles"));
var _SpecificComponentPropType = _interopRequireDefault(require("../type-tools/SpecificComponentPropType"));
var _AppBarMobile = _interopRequireDefault(require("./AppBarMobile"));
var _PageHeader = _interopRequireDefault(require("./PageHeader"));
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) {
    if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var AppBar = function AppBar(_ref) {
  var mobile = _ref.mobile,
    desktop = _ref.desktop,
    renderMobileForMediumDevices = _ref.renderMobileForMediumDevices;
  return /*#__PURE__*/_react["default"].createElement(Styled.AppBarWrapper, {
    renderMobileForMediumDevices: renderMobileForMediumDevices
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "appBar__mobile"
  }, mobile), /*#__PURE__*/_react["default"].createElement("div", {
    className: "appBar__desktop"
  }, desktop));
};
AppBar.propTypes = process.env.NODE_ENV !== "production" ? {
  mobile: (0, _SpecificComponentPropType["default"])(_AppBarMobile["default"], 'AppBarMobile'),
  desktop: (0, _SpecificComponentPropType["default"])(_PageHeader["default"], 'PageHeader'),
  renderMobileForMediumDevices: _propTypes["default"].bool
} : {};
AppBar.defaultProps = {
  renderMobileForMediumDevices: false
};
var _default = exports["default"] = AppBar;